export const CHAT_HAS_VISITED_KEY = '_roborobo_widget_has_visited';
